import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Catalogue from 'views/Catalogue';
import CatalogueD8 from 'views/Catalogue/CatalogueD8';

const CatalogueContainer = (props) => {
  const {
    catalogs,
    client,
  } = props;

  switch (client?.design) {
    case 8: 
      return(
        <CatalogueD8
          catalogs={catalogs}
          logoImage={client?.image}
        />
      )
    default:
      return (
        <Catalogue
          catalogs={catalogs}
        />
      );
  }
};

const mapStateToProps = (state) => ({
  catalogs: state.app.catalogs,
  client: state.app.client,
});

CatalogueContainer.propTypes = {
  catalogs: PropTypes.arrayOf(PropTypes.shape({
    title: PropTypes.string,
    pdf: PropTypes.string,
  })).isRequired,
  client: PropTypes.shape({
    design: PropTypes.number,
  }),
  marcasHome: PropTypes.arrayOf(PropTypes.shape()).isRequired,
};

CatalogueContainer.defaultProps = {
  client: null,
};

export default connect(mapStateToProps)(CatalogueContainer);